import type {
	ListSignatureRequestTemplatesResponseJSON,
	SignatureRequestTemplateSortBy,
} from "@performyard/service-contracts";

import request from "./internal-api/internal-base-request";

export type { SignatureRequestTemplateSortBy };

export type ListSignatureRequestTemplatesParams = {
	sortBy?: SignatureRequestTemplateSortBy;
	sortOrder?: "asc" | "desc";
	limit?: number;
	skip?: number;
};

export const getSignatureRequestTemplates = async (
	params: ListSignatureRequestTemplatesParams = {}
): Promise<ListSignatureRequestTemplatesResponseJSON> => {
	const searchParams = new URLSearchParams();
	if (params.sortBy) searchParams.set("sortBy", params.sortBy);
	if (params.sortOrder) searchParams.set("sortOrder", params.sortOrder);
	if (params.limit !== undefined) searchParams.set("limit", String(params.limit));
	if (params.skip !== undefined) searchParams.set("skip", String(params.skip));

	const query = searchParams.toString();
	const [response] = await request<ListSignatureRequestTemplatesResponseJSON>(
		`/v1/signature-request-templates${query ? `?${query}` : ""}`,
		{ method: "GET" }
	);
	return response;
};
